// extracted by mini-css-extract-plugin
module.exports = {"image":"_css_image__AhR0Q"};